import { getApi } from '../../../utils/api'

export function getAttachedTasks(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/pipeline/activity-options/',
    params,
  })
}
